
import MasterLayout from "@/layouts/master";
export default [
	{
    path: "/afiliado",
    component: MasterLayout,
    children: [
      {
        path: "ficha",
        name: "afiliado.ficha",
        component: () => import("@/views/afiliado/ficha/index.vue")
      },
      {
        path: "incapacidades",
        name: "afiliado.incapacidades",
        component: () => import("@/views/afiliado/incapacidades/index.vue")
      },
      {
        path: "nomina",
        name: "afiliado.nomina",
        component: () => import("@/views/afiliado/nomina/index.vue")
      },
      {
        path: "liquidacion",
        name: "afiliado.liquidacion",
        component: () => import("@/views/afiliado/liquidacion/index.vue")
      },
      {
        path: "crear",
        name: "afiliado.crear",
        component: () => import("@/views/afiliado/crear/index.vue")
      },
    ]
  }
]